"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var diactrics = 'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'.split('');
  return email.split('').every(function (_char) {
    return !diactrics.includes(_char);
  });
};
exports["default"] = _default;